import { InquiryCustomCakeDeliveryType } from "../InquiryCustomCakeDeliveryType.js";
import { Locale, type LocalizedString } from "../Locale.js";

export const inquiryCustomCakeDeliveryTypeNameMap = {
	[InquiryCustomCakeDeliveryType.DeliveryToAddress]: {
		[Locale.cs]: "Rozvoz na adresu",
	},
	[InquiryCustomCakeDeliveryType.PickUpCakovice]: {
		[Locale.cs]: "Vyzvednutí na pobočce – Čakovice",
	},
	[InquiryCustomCakeDeliveryType.PickUpPetriny]: {
		[Locale.cs]: "Vyzvednutí na pobočce – Petřiny",
	},
} satisfies Record<InquiryCustomCakeDeliveryType, LocalizedString>;
